<!-- Url Iframe modal -->
<template>
    <iframe
        id="myIframe"
        @load="myIframeload"
        width="100%"
        height="100%"
        :style="height ? {overflow:'auto',height:height} :{overflow:'auto'}"
        frameborder="0"
        :src="url"
    ></iframe>
</template>

<script>
import ModalCallBackType from '@/models/data-list/modal-callback-type.enum.js';
import { IsNull } from '../../utils/utils';

export default {
    name: 'browser-dialog',

    data() {
        return {
            eventListener: [],
            messageHandler: message => {
                const myIframe = document.getElementById('myIframe');
                if (myIframe.contentWindow === message.source) {
                    this.$emit('confirm', message.data);
                }
            },
        };
    },

    props: {
        url: String,
        postData: Object,
        height: String,
    },
    created: function() {
        //添加监听事件。
        window.addEventListener('message', this.messageHandler);
    },
    destroyed: function() {
        //销毁监听,否则会多次接收
        window.removeEventListener('message', this.messageHandler);
        this.removeAllEventListener();
    },

    methods: {
        myIframeload() {
            const myIframe = document.getElementById('myIframe');

            const data = {
                act: ModalCallBackType.Connect, // 自定义的消息类型、行为，用于switch条件判断等。。
                message: {
                    subject: 'message消息通道尝试已连接..',
                },
            };
            // 不限制域名则填写 * 星号, 否则请填写对应域名如 http://www.b.com
            if (this.postData) {
                myIframe.contentWindow.postMessage(this.postData, '*');
            } else {
                myIframe.contentWindow.postMessage(data, '*');
            }
        },
        addEventListener(name, callback) {
            if (IsNull(name)) {
                return;
            }
            this.eventListener.push({
                name: name,
                callback: callback,
            });
            window.addEventListener(name, callback);
        },
        removeEventListener(name, callback) {
            if (!this.eventListener.find(c => c.name == name)) {
                return;
            }
            window.removeEventListener(name, callback);
        },
        removeAllEventListener() {
            this.eventListener.forEach(element => {
                this.removeEventListener(element.name, element.callback);
            });
            this.eventListener = [];
        },
    },
};
</script>
